import { consts } from '@app/styles'
import type React from 'react'
import styled from 'styled-components'
import { getWidthValue } from './functions'
import type {
  ContainerFlexSpaceWidth,
  ContainerFlexSpaced,
  FlexWrap
} from './types'

interface IItemWrapperRawProps {
  className?: string
  style?: React.CSSProperties
  spaced?: ContainerFlexSpaced
  flexWrap?: FlexWrap
  borderPadding?: ContainerFlexSpaceWidth
  spaceWidth?: ContainerFlexSpaceWidth
  children?: React.ReactNode
}

const ItemWrapper: React.FC<IItemWrapperRawProps> = props => {
  return (
    <div className={props.className} style={props.style}>
      {props.children}
    </div>
  )
}

export default styled(ItemWrapper)`
  margin-bottom: ${props => {
    return props.spaced && props.flexWrap === 'wrap'
      ? `${getWidthValue(props.spaceWidth || 'default')}`
      : '0px'
  }};

  ${props => {
    return props.borderPadding
      ? `
        :not(:last-child) {
          border-bottom: 1px solid ${consts.colorBlueGray025};
          padding-bottom: ${getWidthValue(props.borderPadding || 'default')};
        }
      `
      : ''
  }};
`
